var NMASTER = (function () {
  function biq(b, a, inp) {
    var out = new Float32Array(inp.length), x1 = 0, x2 = 0, y1 = 0, y2 = 0;
    for (var i = 0; i < inp.length; i++) { var y = b[0] * inp[i] + b[1] * x1 + b[2] * x2 - a[1] * y1 - a[2] * y2; x2 = x1; x1 = inp[i]; y2 = y1; y1 = y; out[i] = y; }
    return out;
  }
  function kfilter(x, sr) {
    var G = 3.999843853973347, f0 = 1681.974450955533, Q = 0.7071752369554196;
    var K = Math.tan(Math.PI * f0 / sr), Vh = Math.pow(10, G / 20), Vb = Math.pow(Vh, 0.4996667741545416), a0 = 1 + K / Q + K * K;
    var b1 = [(Vh + Vb * K / Q + K * K) / a0, 2 * (K * K - Vh) / a0, (Vh - Vb * K / Q + K * K) / a0], a1 = [1, 2 * (K * K - 1) / a0, (1 - K / Q + K * K) / a0];
    f0 = 38.13547087602444; Q = 0.5003270373238773; K = Math.tan(Math.PI * f0 / sr);
    var d = 1 + K / Q + K * K;
    return biq([1, -2, 1], [1, 2 * (K * K - 1) / d, (1 - K / Q + K * K) / d], biq(b1, a1, x));
  }
  function LU(v) { return -0.691 + 10 * Math.log10(v); }
  // mean-square per hop (100 ms) of K-weighted sum over channels
  function blocks(chs, sr) {
    var f = chs.map(function (c) { return kfilter(c, sr); }), hop = Math.round(0.1 * sr), n = f[0].length, nb = Math.floor(n / hop), ms = new Float64Array(nb);
    for (var b = 0; b < nb; b++) { var s = 0; for (var c = 0; c < f.length; c++) { var d = f[c]; for (var i = b * hop; i < (b + 1) * hop; i++) s += d[i] * d[i]; } ms[b] = s / hop; }
    return ms;
  }
  function win(ms, k) { // average over k hops -> array of mean-square
    var out = []; var acc = 0;
    for (var i = 0; i < ms.length; i++) { acc += ms[i]; if (i >= k) acc -= ms[i - k]; if (i >= k - 1) out.push(acc / k); }
    return out;
  }
  function integrated(ms) {
    var z = win(ms, 4), g1 = z.filter(function (v) { return v > 0 && LU(v) > -70; }); if (!g1.length) return -Infinity;
    var m = g1.reduce(function (a, b) { return a + b; }, 0) / g1.length, rel = LU(m) - 10, g2 = g1.filter(function (v) { return LU(v) > rel; });
    return LU(g2.reduce(function (a, b) { return a + b; }, 0) / g2.length);
  }
  function lra(st) {
    var g1 = st.filter(function (v) { return v > 0 && LU(v) > -70; }); if (g1.length < 2) return 0;
    var m = g1.reduce(function (a, b) { return a + b; }, 0) / g1.length, rel = LU(m) - 20;
    var l = g1.filter(function (v) { return LU(v) > rel; }).map(LU).sort(function (a, b) { return a - b; });
    if (l.length < 2) return 0;
    var q = function (p) { return l[Math.min(l.length - 1, Math.max(0, Math.round(p * (l.length - 1))))]; };
    return q(0.95) - q(0.10);
  }
  // 4x oversampled true peak (windowed-sinc interpolation, 12 taps per phase)
  var TP = (function () {
    var taps = 32, ph = 4, h = [];
    for (var p = 0; p < ph; p++) {
      var row = [], frac = p / ph, sum = 0;
      for (var t = 0; t < taps; t++) {
        var x = t - taps / 2 + 1 - frac, s = x === 0 ? 1 : Math.sin(Math.PI * x) / (Math.PI * x), w = 0.5 + 0.5 * Math.cos(Math.PI * x / (taps / 2));
        row.push(s * w); sum += s * w;
      }
      h.push(row.map(function (v) { return v / sum; }));
    }
    return h;
  })();
  function truePeak(d) {
    var m = 0, n = d.length;
    for (var i = 0; i < n; i++) { var a = d[i] < 0 ? -d[i] : d[i]; if (a > m) m = a; }
    for (i = 15; i < n - 16; i++) {
      var near = Math.abs(d[i]); if (near < m * 0.5) continue;
      for (var p = 1; p < 4; p++) {
        var r = TP[p], s = 0; for (var t = 0; t < 32; t++) s += r[t] * d[i - 15 + t];
        if (s < 0) s = -s; if (s > m) m = s;
      }
    }
    return m;
  }
  function db(v) { return v > 0 ? 20 * Math.log10(v) : -Infinity; }
  function bands(chs, sr) { // average spectrum energy in 6 bands (dB, relative)
    var n = 4096, mono = chs[0], c2 = chs[chs.length - 1], E = [0, 0, 0, 0, 0, 0], edges = [20, 60, 250, 2000, 6000, 12000, 20000], cnt = 0;
    var step = Math.max(n, Math.floor(mono.length / 60));
    for (var off = 0; off + n <= mono.length; off += step) {
      var re = new Float64Array(n), im = new Float64Array(n);
      for (var i = 0; i < n; i++) re[i] = (mono[off + i] + c2[off + i]) * 0.5 * (0.5 - 0.5 * Math.cos(2 * Math.PI * i / (n - 1)));
      for (var a = 1, j = 0; a < n; a++) { var bit = n >> 1; for (; j & bit; bit >>= 1) j ^= bit; j ^= bit; if (a < j) { var t = re[a]; re[a] = re[j]; re[j] = t; } }
      for (var len = 2; len <= n; len <<= 1) {
        var ang = -2 * Math.PI / len, wr0 = Math.cos(ang), wi0 = Math.sin(ang);
        for (var s = 0; s < n; s += len) { var wr = 1, wi = 0; for (var k = 0; k < len / 2; k++) { var u = s + k, v = u + len / 2, tr = wr * re[v] - wi * im[v], ti = wr * im[v] + wi * re[v]; re[v] = re[u] - tr; im[v] = im[u] - ti; re[u] += tr; im[u] += ti; var nw = wr * wr0 - wi * wi0; wi = wr * wi0 + wi * wr0; wr = nw; } }
      }
      for (k = 1; k < n / 2; k++) { var f = k * sr / n, e = re[k] * re[k] + im[k] * im[k]; for (var bnd = 0; bnd < 6; bnd++) if (f >= edges[bnd] && f < edges[bnd + 1]) { E[bnd] += e; break; } }
      cnt++;
    }
    var tot = E.reduce(function (x, y) { return x + y; }, 0) || 1;
    return E.map(function (e) { return 10 * Math.log10(e / tot + 1e-12); });
  }
  function analyze(chs, sr) {
    var ms = blocks(chs, sr), st = win(ms, 30), mom = win(ms, 4);
    var I = integrated(ms), tp = 0, sp = 0, clip = 0;
    chs.forEach(function (d) {
      var t = truePeak(d); if (t > tp) tp = t;
      var run = 0; for (var i = 0; i < d.length; i++) { var a = Math.abs(d[i]); if (a > sp) sp = a; if (a >= 0.9995) { run++; if (run === 3) clip++; } else run = 0; }
    });
    var corr = 1;
    if (chs.length > 1) { var l = chs[0], r = chs[1], lr = 0, ll = 0, rr = 0; for (var i = 0; i < l.length; i += 4) { lr += l[i] * r[i]; ll += l[i] * l[i]; rr += r[i] * r[i]; } corr = ll && rr ? lr / Math.sqrt(ll * rr) : 1; }
    return {
      lufs: I, tp: db(tp), sp: db(sp), lra: lra(st), stMax: st.length ? LU(Math.max.apply(null, st)) : I, momMax: mom.length ? LU(Math.max.apply(null, mom)) : I,
      curve: st.map(LU), clips: clip, corr: corr, dur: chs[0].length / sr, bands: bands(chs, sr)
    };
  }
  // platform playback: gain the platform applies (dB)
  var PLAT = [
    { n: 'Spotify', t: -14, up: true },
    { n: 'Apple Music', t: -16, up: false },
    { n: 'YouTube', t: -14, up: false },
    { n: 'Amazon Music', t: -14, up: true },
    { n: 'TIDAL', t: -14, up: true },
    { n: 'Deezer', t: -15, up: false }
  ];
  function platforms(r) {
    return PLAT.map(function (p) {
      var g = p.t - r.lufs;
      if (g > 0) g = p.up ? Math.max(0, Math.min(g, -1 - r.tp)) : 0;
      return { n: p.n, gain: g, played: r.lufs + g };
    });
  }
  return { analyze: analyze, platforms: platforms };
})();
if (typeof module !== 'undefined') module.exports = NMASTER;
